/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Access_Conflict_ResolveInputs */



/**
* | output |
* | --- |
* | "Resolve Conflicts" |
*
* @param {Project_Access_Conflict_ResolveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_conflict_resolve = /** @type {((inputs?: Project_Access_Conflict_ResolveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Conflict_ResolveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konflikte lösen")
	return /** @type {LocalizedString} */ ("Resolve Conflicts")
});